var app = angular.module("leonardo");

var MyApprovalTasks = function($scope,  AuthDataService, AccountService) {

  $scope.block_taks = {};

  $scope.showNoData = function () {
    var results = 0;
    var blocks = Object.keys($scope.block_taks).length;
    angular.forEach($scope.block_taks, function (element) {
      results += element;
    });
    return blocks >= 3 && results <= 0;
  }

  $scope.orderTypes = [
    {id: 'revision_number' , label: 'Revisions-# <br /> (Lowest to Highest)'},
    {id: '-revision_number' , label: 'Revisions-# <br /> (Highest to Lowest)'},
    {id: 'active_approval_step__index' , label: 'Step # (Lowest to Highest)'},
    {id: '-active_approval_step__index' , label: 'Step # (Highest to Lowest)'},
    {id: '-original_submission' , label: 'Original Submission Date <br /> (Newest to Oldest)'},
    {id: 'original_submission' , label: 'Original Submission Date <br /> (Oldest to Newest)'},
    {id: '-active_approval_step__created' , label: 'Latest Submission Date <br /> (Newest to Oldest)'},
    {id: 'active_approval_step__created' , label: 'Latest Submission Date <br /> (Oldest to Newest)'},
    {id: '-active_approval_step__due_date' , label: 'Due Date (Newest to Oldest)'},
    {id: 'active_approval_step__due_date' , label: 'Due Date (Oldest to Newest)'},
    {id: 'original_submitter' , label: 'Original Submitter <br /> (A-Z by First Name)'},
    {id: '-original_submitter' , label: 'Original Submitter (Z-A)'},
    {id: 'current_approver' , label: 'Current Approver <br /> (A-Z by First Name)'},
    {id: '-current_approver' , label: 'Current Approver (Z-A)'},
    {id: 'workflow_instance__name' , label: 'Workflow name (A-Z)'},
    {id: '-workflow_instance__name' , label: 'Workflow name (Z-A)'}
  ];
  
  $scope.addOrderTypes = function(){
    if(AuthDataService.authData.account && AuthDataService.authData.account.id){
      AccountService.get(AuthDataService.authData.account.id).then((result) => {
        if ((result.managed_to_me && result.managed_to_me.length > 0) || (result.managed_by_me && result.managed_by_me.length > 0)) {
          let newOptions = [...$scope.orderTypes];
          newOptions.push(
            { id: 'managed_by', label: 'Management Company <br /> (A-Z by First Name)' },
            { id: '-managed_by', label: 'Management Company <br /> (Z-A)' }
          );
          $scope.orderTypes = [...newOptions];
        }
      });
    }
  }

  $scope.addOrderTypes();

  $scope.$on('my-approvals-tasks:updated', function($event, mode, tasks){
    $scope.block_taks[mode] = tasks;
  });

  $scope.$on('filter-selection:updated', function(){
    $scope.block_taks = {};
  });

};

app.controller('MyApprovalTasks', ['$scope', 'AuthDataService', 'AccountService', MyApprovalTasks]);
